$(window).on('datepicker:opened datepicker:month-changed',function(e, instance){
    // init
    let window_width = $(window).width();
    // on small or larger screens, adjust popup calendar to input width
    if (window_width <= 768 || window_width >= 1300) {
        let $source_input = $(instance.altInput);
        let source_input_width = $source_input.outerWidth();
        if (window_width <= 768) {
            source_input_width = source_input_width - 2; // respect border
        }else {
            // default context
            source_input_width = source_input_width - 2;
            // booking-widget context
            if ($source_input.parents('.booking-widget').length > 0) {
                source_input_width = source_input_width + 1; // respect border
            }
        }
        let $calendar = $(instance.calendarContainer);
        $calendar.width(source_input_width);
    }
});

$(window).on('datepicker:month-changed', function(e, instance){
    // init
    let window_width = $(window).width();
    // on small or larger screens, adjust popup calendar to input width
    if (window_width <= 768 || window_width >= 1300) {
        let $calendar = $(instance.calendarContainer);
        $calendar.addClass('month-transitioning');
        setTimeout(function(){
            $calendar.removeClass('month-transitioning');
        },400);
    }
});

$(window).on('datepicker:value-updated', function(e, instance){
    // init
    let $input = $(instance.element);
    let calendar_id = $input.attr('id');
    if (calendar_id.indexOf('booking-departure-date') === 0) {
        let date_to_be_set = $input.val();
        let min_date = $input.data('minDate');
        for (var i = window.flatpickr_instances.length - 1; i >= 0; i--) {
            if (window.flatpickr_instances[i] === instance) {
                window.flatpickr_instances[i].setDate(date_to_be_set);
                window.flatpickr_instances[i].open();
            }
        }
    }
});

$(window).on('datepicker:change', function(e, instance){
    let $input = $(instance.element);
    let calendar_id = $input.attr('id');
    if (calendar_id.indexOf('booking-arrival-date') === 0) {
        // init
        let widget_id = $input.parents('.booking-widget').data('widget-id');
        // cleanup selected date
        let selected_date = $input.val();
        let date_array = selected_date.split('-');
        // determine the day after and add a day to the date
        selected_date = new Date(parseInt(date_array[2]), parseInt(date_array[1])-1, parseInt(date_array[0]));
        const day_after_time = new Date(selected_date.getTime() + 86400000); // + 1 day in ms
        const day_after = day_after_time.toLocaleDateString({}, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
        let day_after_date_array = day_after.split('/');
        let departure_date_selector = '#booking-departure-date-' + widget_id;
        $(departure_date_selector).val(day_after_date_array[1]+'-'+day_after_date_array[0]+'-'+day_after_date_array[2])
                                  .trigger('change');

        // set min date (not possible in datepicker:value-updated event, causes endless loop)
        for (var i = window.flatpickr_instances.length - 1; i >= 0; i--) {
            const $departure_date_element = $(departure_date_selector).get(0);
            if (window.flatpickr_instances[i].element === $departure_date_element) {
                window.flatpickr_instances[i].set('minDate', day_after_time);
            }
        }
    }
});

// $(window).on('datepicker:ready', function(e, instance){
//     let $input = $(instance.element);
// });

function initBookingWidget() {

}

// on page load
initBookingWidget();

$(window).on('default-modal:opened', function(){
    initBookingWidget();
});



// WEBPACK FOOTER //
// ./static/js/modules/datepicker.js